import { NextApiRequest } from 'next'
import { getSession } from 'next-auth/react'

export const getAccessToken = async (req: NextApiRequest) => {
	const session = await getSession({ req })

	return session?.access
}

export function declineToken(balance: string): string {
	const cases = [2, 0, 1, 1, 1, 2]
	const forms = ['токен', 'токена', 'токенов']

	const number = Math.floor(+balance)

	const res = forms[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]

	return `${number} ${res}`
}
